import { ActionType } from "../action-types/type";
import { LanguageAction } from "../actions/index";
import { eng, LanguageData } from "../../util/languageData";

interface LanguageState {
  appLanguage: string;
  data: LanguageData;
}

const initialState: LanguageState = {
  appLanguage: "en",
  data: eng,
};

export function languageReducer(
  state: LanguageState = initialState,
  action: LanguageAction
): LanguageState {
  switch (action.type) {
    case ActionType.SET_APP_LANGUAGE:
      return {
        ...state,
        appLanguage: action.payload.languageId,
        data: action.payload.data,
      };
    default:
      return state;
  }
}